// Ported verbatim from the LeadMailer Design System (components/overlays/EmptyState.jsx).
import React from 'react'

export interface EmptyStateProps {
  icon?: React.ReactNode
  title: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  style?: React.CSSProperties
}

export function EmptyState({ icon, title, description, action, style }: EmptyStateProps) {
  return (
    <div
      /* Addressable: a screen showing its empty state has legitimately rendered
         no data surface, and the visual sweep needs to tell that apart from a
         screen that simply failed to paint one. */
      className="lm-empty"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '28px 16px',
        textAlign: 'center',
        ...style,
      }}
    >
      {icon && (
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 'var(--radius-md)',
            background: 'var(--surface-sunken)',
            border: '1px solid var(--border-default)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--text-muted)',
            marginBottom: 4,
          }}
        >
          {icon}
        </div>
      )}
      <div
        style={{
          fontSize: 'var(--text-base)',
          fontWeight: 'var(--weight-semibold)' as React.CSSProperties['fontWeight'],
          color: 'var(--text-primary)',
        }}
      >
        {title}
      </div>
      {description && (
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text-muted)', maxWidth: 340 }}>
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  )
}
